import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserInputData } from 'src/app/auth/login/login-with-otp/login-with-otp.component';
import { AuthService } from '../../services/http/auth/auth.service';
import { UtilService } from '../../services/util/util.service';

@Component({
  selector: 'app-enter-otp',
  templateUrl: './enter-otp.component.html',
  styleUrls: ['./enter-otp.component.scss']
})
export class EnterOtpComponent implements OnInit, OnDestroy {
  @Input() userInputData!: UserInputData;
  @Output() userOutputData: any = new EventEmitter();
  @Output() enterPressed = new EventEmitter<void>();

  private resendOTP$: Subscription = new Subscription();

  text1: string = "";
  text2: string = "";
  text3: string = "";
  text4: string = "";

  otpForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private utilService: UtilService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    // console.log("this.userInputData=>",this.userInputData);
    this.otpForm = this.fb.group({
      text1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      text2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      text3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      text4: ['', [Validators.required, Validators.pattern('[0-9]')]]
    });
  }

  onEnterPressed(): void {
    this.emitOtp();
    this.enterPressed.emit();
  }

  emitOtp(): void {
    const { text1, text2, text3, text4 } = this.otpForm.value;
    const otp = `${text1}${text2}${text3}${text4}`;
    this.userOutputData.emit({
      otp: otp,
    });
  }

  moveToNext(event: Event, nextFieldId: string) {
    const input = event.target as HTMLInputElement;

    if (input.value.length === 1 && nextFieldId) {
      const nextField = document.getElementById(nextFieldId) as HTMLInputElement;
      setTimeout(() => {
        nextField?.focus();
      }, 10); // Timeout ensures smooth focus on iOS
    }
    this.emitOtp();
  }

  handleBackspace(event: KeyboardEvent, prevFieldId: string) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && input.value.length === 0 && prevFieldId) {
      const prevField = document.getElementById(prevFieldId) as HTMLInputElement;
      setTimeout(() => {
        prevField?.focus();
      }, 10); // Timeout ensures smooth focus on iOS
    }
    this.emitOtp();
  }

  resendOTP() {
    this.otpForm.reset();
    this.emitOtp();
    // if (!this.canResend) {
    //     return false;
    // }

    if (this.userInputData.phone) {
      const obj = {
        phone: this.userInputData.phone,
        otp_type: this.userInputData.otp_type
      }
      this.resendOTP$ = this.authService.sentOtp(obj).subscribe({
        next: (res: any) => {
          this.utilService.showSuccessSnackbar({
            msg: 'OTP has been resent to registered mobile number.',
            showIcon: false
          });
          // this.startTimer();
        },
        error: (err: any) => {
          this.utilService.showErrorSnackbar({
            msg: err?.error?.message
          });
        }
      });
    }

    // return true;
  }

  ngOnDestroy() {
    // if (this.timerInterval) {
    //   clearInterval(this.timerInterval);
    // }
    this.resendOTP$?.unsubscribe();
  }
}
